import { Fragment, useEffect } from "react";
import useGlobal from "../../../../store";
import cookie from 'react-cookies';
import useReloadDummy from "../../../scripts/hooks/use.reload.dummy";

const Protected = ({ children }) => {

	const [ globalState, globalActions ] = useGlobal();
  const { sign } = globalActions;
	const token = cookie.load('token');

	const [ Dummy, reloadDummy ] = useReloadDummy();

	useEffect(() => { 

    console.log(`Protected token = `, token);
		
		token 
			? sign.Check( token, reloadDummy )
			: sign.Out()
	
	}, []);

	return (

		<Fragment>

			<Dummy />
			{ children }

		</Fragment>
	
	);

}

export default Protected;